import { toString } from 'lodash';

export const removeNode = () => {
  const recursive = (id, list = []) => {
    for (let item of list) {
      if (item.id === id) {
        list = list.filter((el) => el.id !== id);
        break;
      }

      if (item.children) {
        item.children = item.children.filter((el) => el.id !== id);
        recursive(id, item.children);
      }
    }

    return list;
  };

  return recursive;
};

export const findNode = () => {
  let result;

  const recursive = (id, listChildren) => {
    for (let node of listChildren) {
      if (toString(id) === toString(node.id)) {
        result = node;
        break;
      }
      if (node.children && typeof node.children === 'object') {
        result = recursive(id, node.children);
        if (result) {
          break;
        }
      }
    }

    return result;
  };

  return recursive;
};
